"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveObject = void 0;
/**
 * Saves an object in the web storage
 * @alpha
 *
 * @typeParam T - the type of the object to be saved.
 *
 * @param key - The key identifying the object in the storage
 * @param object - A default value to set in case the object does not exist in the storage
 *
 * @example
 * ```ts
 * saveObject('example', {a: 'b'});
 * ```
 */
function saveObject(key, object) {
    localStorage.setItem(key, JSON.stringify(object));
}
exports.saveObject = saveObject;
//# sourceMappingURL=save-object.js.map